import { render } from "./ISenler.vue?vue&type=template&id=586c355a"
import script from "./ISenler.vue?vue&type=script&lang=js"
export * from "./ISenler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__